import * as ACTION_TYPES from './constants';

import { Student as Api } from '../../Api';

import { Toast } from '../Common';

const reducer = 'StudentReducer';

export default class StudentActions {
    static loading_index = toggle => ({
        type: ACTION_TYPES.STUDENT_LOADING_INDEX,
        toggle,
    });

    static loading_show = toggle => ({
        type: ACTION_TYPES.STUDENT_LOADING_SHOW,
        toggle,
    });

    static search =
        (search = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: ACTION_TYPES.STUDENT_SEARCH, search });
        };

    static requests = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index(true));
            const query = getState()[reducer].get('search');
            const res = await Api.index(query);
            if (res instanceof Error) throw res;
            dispatch(this.index(res));
        } catch (error) {
            dispatch(this.loading_index(false));
            console.error(error);
        } finally {
        }
    };

    static index = (students = []) => ({
        type: ACTION_TYPES.STUDENT_INDEX,
        students,
    });

    static request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.show(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const body = getState()[reducer].get('student');
            const res = await Api.create(body);
            if (res instanceof Error) throw res;
            Toast.success('记录已保存');
            dispatch(this.requests());
            dispatch(this.options());
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static patch = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index());
            const res = await Api.patch(body);
            if (res instanceof Error) throw res;
            Toast.success('记录已保存');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_index(false));
            console.error(error);
        } finally {
        }
    };

    static destroy = () => async (dispatch, getState) => {
        try {
            const params = getState()[reducer].getIn(['student', 'id']);
            dispatch(this.loading_show());
            const res = await Api.destroy(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static show = (student = {}) => ({
        type: ACTION_TYPES.STUDENT_SHOW,
        student,
    });

    static reset = () => ({
        type: ACTION_TYPES.STUDENT_RESET,
    });

    static column = (columns = []) => ({
        type: ACTION_TYPES.STUDENT_COLUMN,
        columns,
    });

    static options = () => async (dispatch, getState) => {
        try {
            const res = await Api.options();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.STUDENT_OPTION,
                options: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    static school = () => async (dispatch, getState) => {
        try {
            const res = await Api.school();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.STUDENT_SCHOOL,
                schools: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };
}
